import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { BreadCrumbSteps } from "@sequentech/ui-essentials";
import { selectBypassChooser } from "../store/extra/extraSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
export default function Stepper(_a) {
    var selected = _a.selected, warning = _a.warning;
    var dispatch = useAppDispatch();
    var bypassElectionChooser = useAppSelector(selectBypassChooser());
    var computedSelected = bypassElectionChooser ? (selected === 0 ? 0 : selected - 1) : selected;
    var list = [
        "breadcrumbSteps.ballot",
        "breadcrumbSteps.review",
        "breadcrumbSteps.confirmation",
    ];
    if (!bypassElectionChooser) {
        list.unshift("breadcrumbSteps.electionList");
    }
    return _jsx(BreadCrumbSteps, { labels: list, selected: computedSelected, warning: warning });
}
